<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<app-progress-bar [isLoading]="isLoading"></app-progress-bar>
<div class="row fixed-bar-sticky mx-1 mt-1">
  <div class="col-12 d-flex justify-content-end">
    <div class="fixed-bar align-items-center">
      <div class="user_online">
        <span *ngFor="let item of logedInUserList"> <i class="fa fa-circle text-success mr-1" aria-hidden="true"></i> {{
          item.UserName }}
        </span>
      </div>
      <!-- on condition -->
      <span *ngIf="logedInUserList.length>0" class="px-2">|</span>
      <!-- on condition -->
      <div class="fixed-bar-link d-flex">
        <span class="mb-2 text-muted" *ngIf="checkSibling(selfAssessmentId, 'Previous')">
          <span class="text-blue float-right" (click)="getSiblings('Previous')">Previous</span>
        </span>
        <span class="mb-2 text-muted" *ngIf="checkSibling(selfAssessmentId, 'Next')">
          <span class="text-blue float-right" (click)="getSiblings('Next')">Next</span>
        </span>
        <span class="cursor-pointer text-primary cursor-pointer" [ngClass]="{'disabled': isApprovedForDisable}">
          <i class="fa fa-square-o icon-font vertical-align-middle"
            (click)="selfAssessmentNew.isSendNotification = true" *ngIf="!selfAssessmentNew.isSendNotification"
            aria-hidden="true"></i>
          <i class="fa fa-check-square icon-font vertical-align-middle"
            (click)="selfAssessmentNew.isSendNotification = false" *ngIf="selfAssessmentNew.isSendNotification"
            aria-hidden="true"></i>
          Send Notification
        </span>
        <span class="cursor-pointer text-primary cursor-pointer" (click)="openDialog()"
          [ngClass]="{'disabled': isApprovedForDisable}"><i class="fa fa-history text-dark"></i> Version History </span>
        <a href="/self-assessment/details/self/2/{{selfAssessmentNew.id}}" *ngIf="filterType === 'version'"
          class="cursor-pointer text-primary cursor-pointer"><i class="fa fa-undo text-dark"></i>
          Current Version</a>
        <span class="cursor-pointer text-primary cursor-pointer" *ngIf="filterType === 'self'"
          [ngClass]="{'disabled': isApprovedForDisable}" (click)="updateSelfAssessment()"><i
            class="fa fa-floppy-o text-dark"></i>
          Save </span>
      </div>

    </div>
  </div>
</div>
<div class="row mt-1 mb-1 mx-1">
  <div class="col-12 accordions">
    <mat-accordion id="RuleDetails" class="mt-1">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Rule Details <span *ngIf="isVersioned" class="marking-changed-fields">Version {{versionNo}} </span>
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="SummaryDetails">
          <div class="row ml-2 mt-4">
            <div class="col-lg-2">
              <label class="control-label fw">Change ID</label>
              <div class="pt-1 d-flex flex-wrap gap-1" *ngIf="selfAssessmentNew.rulebookRuleID">
                <!-- <p class="mb-0" *ngFor="let rId of selfAssessmentNew.rulebookRuleID.split('|')"><a (click)="openView(rId,2)" target="_blank">{{rId}}</a></p> -->
                <a class="mb-0 redirect_tag" *ngFor="let rId of selfAssessmentNew.rulebookRuleID.split('|')"
                  (click)="openView(rId, 2)" target="_blank">{{ rId }}</a>
              </div>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="left inline label-heading control-label mb-1 fw">Part</div>
                <div class="input-group self_part pt-1">
                  <p class="mb-0" *ngFor="let rPart of selfAssessmentNew.part.split(',').slice(0, 5)">{{ rPart }}</p>
                  <ng-container *ngIf="selfAssessmentNew.part.split(',').length > 5">
                    <p class="mb-0"><b>Note : </b><span class="d-inline bg-warning">You have to check the rulebook for
                        seeing the relevant parts.</span> </p>
                  </ng-container>

                  <!-- <p class="mb-0" *ngFor="let rPart of selfAssessmentNew.part.split(',')">{{rPart}}</p> -->
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <label class="control-label fw">Regulator</label>
              <div class="pt-1" *ngIf="selfAssessmentNew.regulator">
                <p class="mb-0" *ngFor="let item of selfAssessmentNew.regulator.split('|')">{{item}}</p>
              </div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Date</label>
              <div class="pt-2 control-label">{{effectiveDate | date: 'dd-MMM-yyyy'}}</div>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Rulebook</label>
              <div class="pt-2" *ngIf="selfAssessmentNew.ruleBook">
                <p class="mb-0" *ngFor="let item of selfAssessmentNew.ruleBook.split('|')">{{item}}</p>
              </div>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Rule ID</label>
              <div class="pt-2" *ngIf="selfAssessmentNew.ruleID">
                <p class="mb-0" *ngFor="let item of selfAssessmentNew.ruleID.split('|').slice(0, 5)">{{ item }}</p>
                <ng-container *ngIf="selfAssessmentNew.ruleID.split('|').length > 5">
                  <p class="mb-0"><b>Note : </b><span class="d-inline bg-warning">You have to check the rulebook for
                      seeing the relevant Rule IDs.</span> </p>
                </ng-container>
                <!-- <p class="mb-0" *ngFor="let item of selfAssessmentNew.ruleID.split('|')">{{item}}</p> -->
              </div>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Division</label>
              <div class="pt-2 control-label">{{selfAssessmentNew.jurisdiction}}</div>
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-10 fw">
              <label class="control-label fw">Description</label>
              <div class="edit_status_changeViewer_group">
                <div *ngFor="let item of selfAssessmentNew.regulatoryRuleFullRequirement.split('|').slice(0,5)">
                  <div *ngIf="item | hasHtmlTags; else noHtmlTags" [innerHTML]="item"></div>
                  <ng-template #noHtmlTags>
                    <mat-form-field class="disableText w-100">
                      <textarea matInput cdkTextareaAutosize disabled
                        class="text-area-css textarea_input">{{item}}</textarea>
                    </mat-form-field>
                  </ng-template>
                </div>
                <ng-container *ngIf="selfAssessmentNew.regulatoryRuleFullRequirement.split(',').length > 5">
                  <p class="mb-0"><b>Note : </b><span class="d-inline bg-warning">You have to check the rulebook for
                      seeing the relevant Descriptions.</span> </p>
                </ng-container>
              </div>
            </div>

            <div class="col-lg-2" *ngIf="selfAssessmentNew.hyperlink">
              <a href="{{selfAssessmentNew.hyperlink}}" target="_blank">
                <i class="fa fa-globe"></i>
                <span class="text-primary cursor-pointer">
                  Source Link</span>
              </a>
            </div>
            <div class="col-lg-2" *ngIf="!selfAssessmentNew.hyperlink">
              <i class="fa fa-globe"></i><span> Source Link</span>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="KeyInformation">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Key Information
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row rule_owner_row ml-2 mt-1">
          <div class="col-lg-4 mb-3">
            <label class="control-label fw">Rule Owner</label>
            <div class="applies_accross_row">
              <div *ngIf="ownerDD && ownerDD.length>0">
                <div class="tags_part" *ngFor="let namesString of ownerDD">
                  <div class="d-flex flex-wrap gap-1">
                    <span class="tag" *ngFor="let name of namesString.split(',')">{{ name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Assessment Category</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.assessmentCategory}}</div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Assessment Status</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.assessmentStatus}}</div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Compliance Status</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.complianceStatus}}</div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Approval Status</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.approvalStatus}}</div>
          </div>
        </div>
        <div class="row rule_owner_row ml-2 mt-1">
          <div class="col-lg-3 mb-3">
            <label class="control-label fw">Last Approval Date</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.lastApproved | date: 'dd-MMM-yyyy'}}</div>
          </div>
          <div class="col-lg-3 mb-3">
            <label class="control-label fw">Interpretations</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.interpretation}}</div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Judgements</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.judgement}}</div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Limitations</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.gaps}}</div>
          </div>
          <div class="col-lg-2 mb-3">
            <label class="control-label fw">Actions</label>
            <div class="pt-2 control-label control-input">{{selfAssessmentNew.enhancement}}</div>
          </div>
        </div>
        <!-- <div class="row rule_owner_row ml-2 mt-1">

        </div> -->
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="OverallAssessment">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Overall Assessment
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Creation Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentCreationDate" (click)="assessmentLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.assessmentCreationDate" name="AssessmentCreationDate" />
              </div>
              <mat-datepicker #assessmentCreationDate></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Due Date <span class="stars">*</span><i
                  *ngIf="filterType !== 'self' && changeFields.includes('AssessmentDueDate')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.assessmentDueDate"
                  name="AssessmentDueDate" (dateInput)="updateSectionLastEdited('Assessment')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="assessmentDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEdited('Assessment')">
              </mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Category <span class="stars">*</span><i
                  *ngIf="filterType !== 'self' && changeFields.includes('AssessmentCategory')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="assessmentCategory" matInput
                [matAutocomplete]="autoRA" style="margin-top:0px" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.assessmentCategory">
              <mat-autocomplete autoActiveFirstOption #autoRA="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Assessment')">
                <mat-option *ngFor="let option of assessmentCategory" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 my-4" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Team <span class="stars">*</span><i
                  *ngIf="filterType !== 'self' && changeFields.includes('AssessmentTeam')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <!-- <input type="text" placeholder="Pick one" aria-label="Number" name="assessmentTeam" matInput
                [matAutocomplete]="autoAT" style="margin-top:0px" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.assessmentTeam">
              <mat-autocomplete autoActiveFirstOption #autoAT="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Assessment')">
                <mat-option *ngFor="let option of assessmentTeam" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete> -->
              <mat-select [(ngModel)]="selfAssessmentNew.assessmentTeam" class="select_border">
                <mat-option *ngFor="let option of assessmentTeam" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Status <span class="stars">*</span><i
                  *ngIf="filterType !== 'self' && changeFields.includes('AssessmentStatus')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [matAutocomplete]="autoAS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.assessmentStatus" />
              <mat-autocomplete autoActiveFirstOption #autoAS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Assessment')">
                <mat-option *ngFor="let option of assessmentStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Compliance Status <span class="stars">*</span><i
                  *ngIf="filterType !== 'self' && changeFields.includes('ComplianceStatus')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [matAutocomplete]="autoCS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.complianceStatus" />
              <mat-autocomplete autoActiveFirstOption #autoCS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Assessment')">
                <mat-option *ngFor="let option of complianceStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Last Edited <i
                  *ngIf="filterType !== 'self' && changeFields.includes('AssessmentLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentLastEdited" (click)="assessmentLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.assessmentLastEdited" name="AssessmentLastEdited"
                  (dateInput)="updateSectionLastEdited('Assessment')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="assessmentLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #assessmentLastEdited></mat-datepicker>
            </div>
          </div>
          <div class="row ml-2 my-4" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
            <div class="col-lg-6">
              <label class="control-label fw">Assessor <i
                  *ngIf="filterType !== 'self' && changeFields.includes('Assessor')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <mat-chip-grid #assessorList>
                <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable && !isVersioned"
                  [removable]="removable && !isVersioned" (removed)="removeAssessor(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input h-33 border-bottom" #assessorInput
                  [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)">
                <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                  {{assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-6">
              <label class="control-label fw">Assessment Description <span class="stars">*</span><i
                  *ngIf="filterType !== 'self' && changeFields.includes('AssessmentDescription')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="text" class="form-control form-control-sm" (keyup)="updateSectionLastEdited('Assessment')"
                [(ngModel)]="selfAssessmentNew.assessmentDescription">
            </div>
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails1"></span>
                <span *ngIf="filterType === 'self' && isSADetails1"></span>
                <span class="control-label fw">
                  Assessment Details
                  <!-- <span *ngIf="filterType !== 'self' && changeFields.includes('AssessmentDetails')"
                    class="marking-changed-fields">Version {{versionNo}} </span>  -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('AssessmentDetails')"
                    class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                (childVariableChange)="onChildVariableChange($event,'assessmentDetails')" id="assessmentDetails"
                *ngIf="isSADetails1" [data]="selfAssessmentNew.assessmentDetails" [userInfo]="user"
                [noteId]="'assessmentDetails'" [editorUsers]="selfAssessmentNew.muteOverallStatusUser"
                [selfAssessmentId]="selfAssessmentId" (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>

          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceAssessment()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Assessment
                <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviAssessment" (change)="handleFileInput($event.target.files)" type="file" multiple
                style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 1">
                  <span class="fa fa-trash pull-right delete-docs"
                    (click)="openDeleteModel(docs.id, 'Assessment')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="Interpretations">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Interpretations
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1" [style.pointer-events]="isInterpretationDisabled ? 'none' : 'auto'">
            <div class="col-lg-3 mr-3 mb-3">
              <label class="control-label fw">Interpretations<i
                  *ngIf="filterType !== 'self' && changeFields.includes('Interpretation')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="Interpretations" matInput
                [matAutocomplete]="autoIP" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.interpretation" />
              <mat-autocomplete autoActiveFirstOption #autoIP="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Interpretations')">
                <mat-option *ngFor="let option of interpretations" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">Interpretation Last Edited<i
                  *ngIf="filterType !== 'self' && changeFields.includes('InterpretationLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="interpretationLastEdited" (click)="interpretationLastEdited.open()"
                  disabled class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.interpretationLastEdited" name="InterpretationLastEdited"
                  (dateInput)="updateSectionLastEdited('Interpretations')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled
                    (click)="interpretationLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #interpretationLastEdited></mat-datepicker>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails2"></span>
                <span *ngIf="filterType === 'self' && isSADetails2"></span>
                <span class="control-label fw">
                  Interpretation Details
                  <!-- <span
                    *ngIf="filterType !== 'self' && changeFields.includes('InterpretationDetails')"
                    class="marking-changed-fields">Version {{versionNo}} </span> -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('InterpretationDetails')"
                    class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                (childVariableChange)="onChildVariableChange($event,'interpretationDetails')" id="interpretationDetails"
                *ngIf="isSADetails2" [data]="selfAssessmentNew.interpretationDetails" [userInfo]="user"
                [noteId]="'interpretationDetails'" [editorUsers]="selfAssessmentNew.muteOverallStatusUser"
                [selfAssessmentId]="selfAssessmentId" (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>
          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceInterpretation()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Interpretation
                <i *ngIf="isInterpretationLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviInterpretation" (change)="handleInterpretationInput($event.target.files)" type="file"
                multiple style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 4">
                  <span class="fa fa-trash pull-right delete-docs"
                    (click)="openDeleteModel(docs.id, 'Interpretation')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Interpretation')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="Judgements">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Judgements
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1" [style.pointer-events]="isJudgementDisabled ? 'none' : 'auto'">
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Judgement<i
                  *ngIf="filterType !== 'self' && changeFields.includes('Judgement')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="Judgement" matInput
                [matAutocomplete]="autoJ" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.judgement" />
              <mat-autocomplete autoActiveFirstOption #autoJ="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Judgement')">
                <mat-option *ngFor="let option of judgement" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Judgement Last Edited<i
                  *ngIf="filterType !== 'self' && changeFields.includes('JudgementLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="judgementLastEdited" (click)="judgementLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.judgementLastEdited"
                  name="JudgementLastEdited" (dateInput)="updateSectionLastEdited('Judgement')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="judgementLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #judgementLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Judgements<i
                  *ngIf="filterType !== 'self' && changeFields.includes('NoOfJudgements')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="number" class="form-control form-control-sm" (keyup)="updateSectionLastEdited('Judgement')"
                [(ngModel)]="selfAssessmentNew.noOfJudgements">
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails3"></span>
                <span *ngIf="filterType === 'self' && isSADetails3"></span>
                <span class="control-label fw">
                  Judgement Details
                  <!-- <span *ngIf="filterType !== 'self' && changeFields.includes('JudgementDetails')"
                    class="marking-changed-fields">Version {{versionNo}} </span> -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('JudgementDetails')"
                    class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                (childVariableChange)="onChildVariableChange($event,'judgementDetails')" id="judgementDetails"
                *ngIf="isSADetails3" [data]="selfAssessmentNew.judgementDetails" [userInfo]="user"
                [noteId]="'judgementDetails'" [editorUsers]="selfAssessmentNew.muteOverallStatusUser"
                [selfAssessmentId]="selfAssessmentId" (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>
          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceDataJudgement()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Judgement
                <i *ngIf="isDataJudgementLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviDataJudgement" (change)="handleDataJudgementInput($event.target.files)" type="file"
                multiple style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 5">
                  <span class="fa fa-trash pull-right delete-docs"
                    (click)="openDeleteModel(docs.id, 'DataJudgement')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'DataJudgement')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ComplianceGaps">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Limitations
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1" [style.pointer-events]="isGapDisabled ? 'none' : 'auto'">
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Limitations<i
                  *ngIf="filterType !== 'self' && changeFields.includes('Gaps')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="Gaps" matInput
                [matAutocomplete]="autoG" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.gaps" />
              <mat-autocomplete autoActiveFirstOption #autoG="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('ComplianceGap')">
                <mat-option *ngFor="let option of gaps" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Limitations<i
                  *ngIf="filterType !== 'self' && changeFields.includes('NoOfGaps')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <input type="number" class="form-control form-control-sm"
                (keyup)="updateSectionLastEdited('ComplianceGap')" [(ngModel)]="selfAssessmentNew.noOfGaps">
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Limitations Requiring Action<i
                  *ngIf="filterType !== 'self' && changeFields.includes('NoOfGapsRiskAccepted')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="number" class="form-control form-control-sm"
                (keyup)="updateSectionLastEdited('ComplianceGap')" [(ngModel)]="selfAssessmentNew.noOfGapsRiskAccepted">
            </div>
            <div class="col-lg-6 mb-3">
              <label class="control-label fw">Limitations Last Edited<i
                  *ngIf="filterType !== 'self' && changeFields.includes('GapsLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="gapsLastEdited" (click)="gapsLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.gapsLastEdited"
                  name="GapsLastEdited" (dateInput)="updateSectionLastEdited('ComplianceGap')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="gapsLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #gapsLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-6 mb-3">
              <label class="control-label fw">Limitation Action Due Date<i
                  *ngIf="filterType !== 'self' && changeFields.includes('GapActionDueDate')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="gapActionDueDate" (click)="gapActionDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.gapActionDueDate"
                  name="GapActionDueDate" (dateInput)="updateSectionLastEdited('ComplianceGap')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="gapActionDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #gapActionDueDate (selectedChanged)="updateSectionLastEdited('ComplianceGap')">
              </mat-datepicker>
            </div>

          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails4"></span>
                <span *ngIf="filterType === 'self' && isSADetails4"></span>
                <span class="control-label fw">
                  Limitation Details
                  <!-- <span *ngIf="filterType !== 'self' && changeFields.includes('GapDetail')"
                    class="marking-changed-fields">Version {{versionNo}} </span> -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('GapDetail')" class="fa fa-check-circle ml-1"
                    style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                (childVariableChange)="onChildVariableChange($event,'gapDetail')" id="gapDetail" *ngIf="isSADetails4"
                [data]="selfAssessmentNew.gapDetail" [userInfo]="user" [noteId]="'gapDetail'"
                [editorUsers]="selfAssessmentNew.muteOverallStatusUser" [selfAssessmentId]="selfAssessmentId"
                (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>
          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceComplianceGaps()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Limitations
                <i *ngIf="isComplianceGapsLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviComplianceGaps" (change)="handleComplianceGapsInput($event.target.files)" type="file"
                multiple style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 6">
                  <span class="fa fa-trash pull-right delete-docs"
                    (click)="openDeleteModel(docs.id, 'ComplianceGaps')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'ComplianceGaps')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="EnhancementDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Actions
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="EnhancementDetails">
          <div class="row ml-2 my-1" [style.pointer-events]="isEnhancementDetailsDisabled ? 'none' : 'auto'">
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Actions<i
                  *ngIf="filterType !== 'self' && changeFields.includes('Enhancement')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="Enhancements" matInput
                [matAutocomplete]="autoE" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.enhancement" />
              <mat-autocomplete autoActiveFirstOption #autoE="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Enhancement')">
                <mat-option *ngFor="let option of enhancement" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Action Last Edited<i
                  *ngIf="filterType !== 'self' && changeFields.includes('EnhancementLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="enhancementLastEdited" (click)="enhancementLastEdited.open()"
                  class="form-control form-control-sm border-bottom" disabled
                  (dateInput)="updateSectionLastEdited('Enhancement')"
                  [(ngModel)]="selfAssessmentNew.enhancementLastEdited" name="enhancementLastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="enhancementLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #enhancementLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Actions<i
                  *ngIf="filterType !== 'self' && changeFields.includes('NoOfEnhancement')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="number" class="form-control form-control-sm" (keyup)="updateSectionLastEdited('Enhancement')"
                [(ngModel)]="selfAssessmentNew.noOfEnhancement">
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Risk Recommendations<i
                  *ngIf="filterType !== 'self' && changeFields.includes('RiskRecommendation')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <input type="number" class="form-control form-control-sm" (keyup)="updateSectionLastEdited('Enhancement')"
                [(ngModel)]="selfAssessmentNew.riskRecommendation">
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Risk Recommendation Due Date<i
                  *ngIf="filterType !== 'self' && changeFields.includes('RiskRecommendationDueDate')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="riskRecommendationDueDate" (click)="riskRecommendationDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.riskRecommendationDueDate" name="RiskRecommendationDueDate"
                  (dateInput)="updateSectionLastEdited('Enhancement')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="riskRecommendationDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #riskRecommendationDueDate (selectedChanged)="updateSectionLastEdited('Enhancement')">
              </mat-datepicker>
            </div>
            <!-- <div class="col-lg-4 mb-3">
              <label class="control-label fw">Risk Recommendation Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="RiskRecommendationStatus" matInput
                [(ngModel)]="selfAssessmentNew.riskRecommendationStatus" [matAutocomplete]="autoRRS"
                class="form-control form-control-sm border-bottom" />
              <mat-autocomplete autoActiveFirstOption #autoRRS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Enhancement')">
                <mat-option *ngFor="let option of riskRecommendationStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div> Removed on request of LBG-->
          </div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails5"></span>
                <span *ngIf="filterType === 'self' && isSADetails5"></span>
                <span class="control-label fw">
                  Action Description
                  <!-- <span
                    *ngIf="filterType !== 'self' && changeFields.includes('EnhancementDescription')"
                    class="marking-changed-fields">Version {{versionNo}} </span> -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('EnhancementDescription')"
                    class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="accessType"
                (childVariableChange)="onChildVariableChange($event,'enhancementDescription')"
                id="enhancementDescription" *ngIf="isSADetails5" [data]="selfAssessmentNew.enhancementDescription"
                [userInfo]="user" [noteId]="'enhancementDescription'"
                [editorUsers]="selfAssessmentNew.muteOverallStatusUser" [selfAssessmentId]="selfAssessmentId"
                (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>
          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceEnhancement()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Action
                <i *ngIf="isEnhancementLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviEnhancement" (change)="handleEnhancementInput($event.target.files)" type="file"
                multiple style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 7">
                  <span class="fa fa-trash pull-right delete-docs"
                    (click)="openDeleteModel(docs.id, 'Enhancement')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Enhancement')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ReviewDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Review Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mb-3" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Reviewer Team<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ReviewTeam')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <!-- <input type="text" placeholder="Pick one" aria-label="Number" name="reviewerTeam" matInput
                [matAutocomplete]="autoRT" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.reviewerTeam">
              <mat-autocomplete autoActiveFirstOption #autoRT="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Review')">
                <mat-option *ngFor="let option of reviewerTeam" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete> -->
              <mat-select [(ngModel)]="selfAssessmentNew.reviewerTeam" class="select_border">
                <mat-option *ngFor="let option of reviewerTeam" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-4 mb-3" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Reviewer<i
                  *ngIf="filterType !== 'self' && changeFields.includes('Reviewer')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <mat-chip-grid #reviewerList>
                <mat-chip-row *ngFor="let reviewer of reviewerDD" [selectable]="selectable && !isVersioned"
                  [removable]="removable && !isVersioned" (removed)="removeReviewer(reviewer)">
                  {{reviewer}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm h-33 mat-autodd-input border-bottom" #reviewerInput
                  [formControl]="searchReviewerCntrl" [matAutocomplete]="reviewerAutocomplete"
                  [matChipInputFor]="reviewerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addReviewer($event)">
              </mat-chip-grid>
              <mat-autocomplete #reviewerAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerEvent($event)">
                <mat-option *ngFor="let reviewer of searchedReviewer" [value]="reviewer.value">
                  {{reviewer.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-2 mb-3" [style.pointer-events]="isReviewDetailsDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Review Status<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ReviewStatus')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [matAutocomplete]="autoRS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.reviewStatus" />
              <mat-autocomplete autoActiveFirstOption #autoRS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Review')">
                <mat-option *ngFor="let option of reviewStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">Review Last Edited<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ReviewLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="reviewLastEdited" (click)="reviewLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.reviewLastEdited"
                  name="ReviewLastEdited" (dateInput)="updateSectionLastEdited('Review')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="reviewLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #reviewLastEdited></mat-datepicker>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails6"></span>
                <span *ngIf="filterType === 'self' && isSADetails6"></span>
                <span class="control-label fw">
                  Review Details
                  <!-- <span *ngIf="filterType !== 'self' && changeFields.includes('ReviewDetails')"
                    class="marking-changed-fields">Version {{versionNo}} </span> -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('ReviewDetails')"
                    class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="reviewAccessType"
                (childVariableChange)="onChildVariableChange($event,'reviewDetails')" id="reviewDetails"
                *ngIf="isSADetails6" [data]="selfAssessmentNew.reviewDetails" [userInfo]="user"
                [noteId]="'reviewDetails'" [editorUsers]="selfAssessmentNew.muteReviewUser"
                [selfAssessmentId]="selfAssessmentId" (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ApprovalDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Approval Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mb-3" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Approval Team<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ApprovalTeam')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <!-- <input type="text" placeholder="Pick one" aria-label="Number" name="approvalTeam" matInput
                [matAutocomplete]="autoAPT" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.approvalTeam">
              <mat-autocomplete autoActiveFirstOption #autoAPT="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Approval')">
                <mat-option *ngFor="let option of approvalTeam" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete> -->
              <mat-select [(ngModel)]="selfAssessmentNew.approvalTeam" class="select_border">
                <mat-option *ngFor="let option of approvalTeam" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-lg-6 mb-3" [style.pointer-events]="isOverAllAssessmentDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Approver<i
                  *ngIf="filterType !== 'self' && changeFields.includes('Approvers')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <mat-chip-grid #approverList>
                <mat-chip-row *ngFor="let approver of approverDD" [selectable]="selectable && !isVersioned"
                  [removable]="removable && !isVersioned" (removed)="removeApprover(approver)">
                  {{approver}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm h-33 mat-autodd-input border-bottom" #approverInput
                  [formControl]="searchApproverCntrl" [matAutocomplete]="approverAutocomplete"
                  [matChipInputFor]="approverList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addApprover($event)">
              </mat-chip-grid>
              <mat-autocomplete #approverAutocomplete="matAutocomplete"
                (optionSelected)="selectedApproverEvent($event)">
                <mat-option *ngFor="let approver of searchedApprover" [value]="approver.value">
                  {{approver.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mb-3" [style.pointer-events]="isApprovalDetailsDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Approval Status<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ApprovalStatus')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <!-- <input type="text" placeholder="Pick one" aria-label="Number" name="ApprovalStatus" matInput
                [matAutocomplete]="autoAS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.approvalStatus" />
              <mat-autocomplete autoActiveFirstOption #autoAS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Approval')">
                <mat-option *ngFor="let option of approvalStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete> -->
              <input type="text" class="form-control form-control-sm" name="ApprovalStatus"
                [(ngModel)]="selfAssessmentNew.approvalStatus" disabled>
            </div>
            <div class="col-lg-4 mb-3" [style.pointer-events]="isApprovalDetailsDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Confirm Approval<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ConfirmApproval')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="d-flex gap-10 align-items-center flex-wrap" style="margin-top: 7px;">
                <span *ngFor="let approval of confirmApproval">
                  <input type="checkbox" [disabled]="approval.approverName != user.fullName"
                    [(ngModel)]="approval.isConfirmed" (change)="toggleConfirmation(approval)" />
                  {{ approval.approverName }}
                </span>
              </div>
            </div>
            <div class="col-lg-4 mb-3" [style.pointer-events]="isApprovalDetailsDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Approval Last Edited<i
                  *ngIf="filterType !== 'self' && changeFields.includes('ApprovalLastEdited')"
                  class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;"
                  aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="approvalLastEdited" (click)="approvalLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.approvalLastEdited"
                  name="ApprovalLastEdited" (dateInput)="updateSectionLastEdited('Approval')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="approvalLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #approvalLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4 mb-3" [style.pointer-events]="isApprovalDetailsDisabled ? 'none' : 'auto'">
              <label class="control-label fw">Last Approved<i
                  *ngIf="filterType !== 'self' && changeFields.includes('LastApproved')" class="fa fa-check-circle ml-1"
                  style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i></label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="lastApproved" (click)="lastApproved.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessmentNew.lastApproved"
                  name="LastApproved" (dateInput)="updateSectionLastEdited('Approval')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="lastApproved.open()"></span>
                </div>
              </div>
              <mat-datepicker #lastApproved></mat-datepicker>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <!-- <div class="box-shadow p-2"> -->
              <div class="header-text">
                <span *ngIf="filterType === 'self' && !isSADetails7"></span>
                <span *ngIf="filterType === 'self' && isSADetails7"></span>
                <span class="control-label fw">
                  Approval Comment (If Required)
                  <!-- <span
                    *ngIf="filterType !== 'self' && changeFields.includes('ApprovalComment')"
                    class="marking-changed-fields">Version {{versionNo}} </span> -->
                  <i *ngIf="filterType !== 'self' && changeFields.includes('ApprovalComment')"
                    class="fa fa-check-circle ml-1" style="color: #ed7709f5; font-size: 20px;" aria-hidden="true"></i>
                </span>
              </div>
              <app-ck-editor-revision class="ck_editor_min_height" [accessType]="approverAccessType"
                (childVariableChange)="onChildVariableChange($event,'approvalComment')" id="approvalComment"
                *ngIf="isSADetails7" [data]="selfAssessmentNew.approvalComment" [userInfo]="user"
                [noteId]="'approvalComment'" [editorUsers]="selfAssessmentNew.muteApproverUser"
                [selfAssessmentId]="selfAssessmentId" (saveEditorDate)="onEditorSave($event)"></app-ck-editor-revision>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>